import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";


const au1Api = createApi({
    reducerPath: "boundary/au1",
    baseQuery: axiosBaseQuery,
    tagTypes: ["au1List"],
    endpoints: (builder) =>({
        au1FindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['au1List'],
            query: (query = '') => ({
                url: "boundary/au1/" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        au1Create: builder.mutation({
            invalidatesTags: ['au1List'],
            query: (data)=>({url: "boundary/au1/", method: "POST", data})
        }),
        au1Update: builder.mutation({
            invalidatesTags: ['au1List'],
            query: (data)=>({url: "/boundary/au1/"+data.id, method: "PUT", data})
        }),
        // console.log(data);
        
        au1Delete: builder.mutation({
            invalidatesTags: ['au1List'],
            query: (id)=>({url: "/boundary/au1/"+id, method: "DELETE"})
        }),
    })
})

export const { useAu1FindAllQuery, useAu1CreateMutation, useAu1UpdateMutation, useAu1DeleteMutation } = au1Api;
export {au1Api};
